// coord-frontend/src/components/conversation/MessageInput.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "../../hooks/useTranslation";

// Mirrors the backend cap (cfg.maxMessageChars / MAX_MESSAGE_CHARS, default
// 12000) so a real user can never reach the 400 message_too_long response —
// the browser stops input at the limit. Counted in UTF-16 code units on both
// sides (String.length here, content.length on the route).
const MAX_MESSAGE_CHARS = 12000;
// Show the remaining-character hint only this close to the limit; the vast
// majority of messages never see it.
const REMAINING_HINT_THRESHOLD = 500;

const MessageInput = ({
  newMessage,
  setNewMessage,
  handleSendMessage,
  disabled = false,
  maxLength = MAX_MESSAGE_CHARS,
}) => {
  const { t } = useTranslation();
  const remaining = maxLength - (newMessage ? newMessage.length : 0);
  const showRemaining = remaining <= REMAINING_HINT_THRESHOLD;

  return (
    <form onSubmit={handleSendMessage} className="w-full">
      <div className="flex w-full">
        <input
          type="text"
          placeholder={t("messageInput.placeholder")}
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          disabled={disabled}
          maxLength={maxLength}
          className="flex-grow px-4 py-3 rounded-l-full bg-background border-0 text-text-primary placeholder:text-text-muted focus:outline-none focus:ring-2 focus:ring-primary transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
        />
        <button
          type="submit"
          disabled={disabled}
          className="bg-primary text-white rounded-r-full py-3 px-6 hover:bg-primary-600 flex items-center justify-center transition-all duration-200 hover:shadow-md active:transform active:scale-95 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>
      {showRemaining && (
        <p className="text-xs text-text-muted text-right mt-1.5 px-4" aria-live="polite">
          {Math.max(0, remaining)} tegn igjen
        </p>
      )}
    </form>
  );
};

export default MessageInput;
